module.exports = __webpack_public_path__ + "static/media/cross-icon.42104e8d.svg";